export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0016.e00b3675.webp";